export const sanitizeVehiclePayload = (vehicleInfo) => {
  if (vehicleInfo.vehicleID) {
    vehicleInfo.consumervehicleid = vehicleInfo.vehicleID;
  }
  return vehicleInfo;
};
